module.exports = __webpack_public_path__ + "img/header.960499dc.jpg";